/**
 * Cookie consent — RGPD / ePrivacy
 * Categorias:
 *   - necessarios: sempre true (não desativável)
 *   - analiticos:  Google Analytics
 *   - marketing:   reservado para uso futuro
 *
 * O consentimento é guardado em localStorage durante 6 meses.
 * Quando o utilizador opt-in nos analíticos, o gtag.js é injetado dinamicamente.
 */
const STORAGE_KEY = 'uf_cookie_consent_v1';
const STORAGE_TTL_MS = 1000 * 60 * 60 * 24 * 180; // 6 meses

const DEFAULT_CONSENT = {
  necessarios: true,
  analiticos: false,
  marketing: false,
  ts: 0
};

export const getConsent = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || !data.ts) return null;
    if (Date.now() - data.ts > STORAGE_TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return { ...DEFAULT_CONSENT, ...data };
  } catch {
    return null;
  }
};

export const saveConsent = (partial) => {
  const next = { ...DEFAULT_CONSENT, ...partial, necessarios: true, ts: Date.now() };
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch { /* ignore */ }
  applyConsent(next);
  window.dispatchEvent(new CustomEvent('uf:consent-updated', { detail: next }));
  return next;
};

export const clearConsent = () => {
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
};

/* -------- Google Analytics (carregamento condicional) -------- */
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let gaLoaded = false;

const loadGA = () => {
  if (gaLoaded || !GA_ID) return;
  gaLoaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { anonymize_ip: true });
};

const updateGtagConsent = (consent) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('consent', 'update', {
    analytics_storage: consent.analiticos ? 'granted' : 'denied',
    ad_storage: consent.marketing ? 'granted' : 'denied',
    ad_user_data: consent.marketing ? 'granted' : 'denied',
    ad_personalization: consent.marketing ? 'granted' : 'denied'
  });
};

export const applyConsent = (consent) => {
  if (!consent) return;
  if (consent.analiticos) {
    loadGA();
  }
  updateGtagConsent(consent);
};

/* Defaults: tudo "denied" antes do consentimento (Consent Mode v2) */
export const initConsentDefaults = () => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500
  });
};

/* Helper para abrir o painel de preferências a partir do footer */
export const openCookiePreferences = () => {
  window.dispatchEvent(new CustomEvent('uf:open-cookie-preferences'));
};
